<template>
    <div class="jump-goodlist">
<!--        <van-nav-bar title="商品列表" left-arrow fixed class="jump-nav-bar" @click-left="back"/>-->
        <div class="jump-header">
            <van-row class="jump-goodlist-navbar">
                <van-col span="3" class="jump-goodlist-navbar-arrow">
                    <van-icon name="arrow-left" @click="back"/>
                </van-col>
                <van-col span="18">
                    <form @submit.prevent="onSubmit">
                        <input name="keyword" class="form-control" type="search" placeholder="搜索" v-model="q">
                    </form>
                </van-col>
                <van-col span="3"  class="jump-goodlist-navbar-arrow">
                    <i class="iconfont icon-sousuo" @click="getGoodsListSuch"></i>
                </van-col>
            </van-row>
        </div>
        <van-row class="jump-goodlist-filter" >
         
          <van-col span="5" class="jump-goodlist-filter-item" :class="orderBy == 0?'active':''" v-show="gcId!='66279'">
              <p @click="orderByList(0)" >销量
                <van-icon name="arrow-down" :class="(orderBy == 0) && (orderType !=true)?'van-icon-arrow-up':''"/>
              </p>
          </van-col>
          <van-col span="5" class="jump-goodlist-filter-item" :class="orderBy == 1?'active':''" v-show="gcId!='66279'">
              <p @click="orderByList(1)" >价格<van-icon name="arrow-down" :class="(orderBy == 1) && (orderType !=true)?'van-icon-arrow-up':''"/>
              </p>
          </van-col>
          <van-col span="5" class="jump-goodlist-filter-item" :class="orderBy == 2?'active':''" v-show="gcId!='66279'">
              <p @click="orderByList(2)">人气<van-icon name="arrow-down" :class="(orderBy == 2) && (orderType !=true)?'van-icon-arrow-up':''"/>
              </p>
          </van-col>
          <van-col span="9" class="text-right jump-goodlist-filter-item" >
              <p @click="showPop()">按条件筛选<van-icon name="arrow"/></p>
          </van-col>
        </van-row>
      <div class="jump-goodlist-body">
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadData"
      >
        <van-row class="jump-goodlist-item" type="flex" v-for="good in goodsList">
            <van-col span="10" class="jump-goodlist-item-img">
                <!-- <a href="#/gooddetail"><img v-bind:src="good.imageUrl" /></a> -->
                <a :href="'#/gooddetail/'+good.id"><img v-bind:src="good.imageUrl" /></a>
            </van-col>
            <van-col span="14" class="jump-goodlist-item-warp" v-if="good.gc_id!='66279'">
                <h4><a :href="'#/gooddetail/'+good.id"><span v-html="good.name"></span> </a></h4>
                <p><span>销量:{{good.alesVolume}}</span><span style="float:right;">人气:{{good.popularity}}</span></p>
               <p class="item-price">
                
                 {{good.price | priceFmt}}
<!--                 <i @click="addCart(good.id)" class="iconfont icon-gouwuche" v-if="good.type!=6"></i>--></p>
            </van-col>
             <van-col span="14" class="jump-goodlist-item-warp" v-if="good.gc_id=='66279'">
                <h4><a :href="'#/gooddetail/'+good.id">专家姓名:&nbsp;&nbsp;<span v-html="good.name"></span> </a></h4>
                <p class="jianjie-title">专家简历：<a :href="'#/gooddetail/'+good.id">{{good.specification_description}}</a></p>
        
            </van-col>
        </van-row>
        </van-list> 
      </div>
        <van-popup v-model="popShow" position="right" :overlay="true" class="gooddlist-filter">
              <van-collapse v-model="activeNames">
                <!-- <van-collapse-item title="地区" name="1">
                    <span class="pop-item" @click="areaByList(i)" :class="areaId==item.id?'active':''" v-for="(item,i) in areas">{{item.areaName}}</span>
                </van-collapse-item> -->
                <van-collapse-item :title="gcId!='66279'?'品牌':'领域'" name="2">
                    <span class="pop-item" @click="brandByList(i)" :class="brandId==item.id?'active':''" v-for="(item,i) in brands">{{item.name}}</span>
                </van-collapse-item>
                <van-collapse-item title="价格区间" name="3" v-show="gcId!='66279'"> 
                    <van-row>
                      <van-col span="7">
                        <van-field v-model="minPrices" placeholder="最低价格" type="number" />
                      </van-col>
                      <van-col span="1">
                        <span style="color:#ebedf0">_</span>
                      </van-col>
                      <van-col span="7">
                        <van-field v-model="maxPrices" placeholder="最高价格" type="number" />
                      </van-col>
                      <van-col span="8" class="text-right">
                        <van-button size="small" @click="priceByList()">确定</van-button>
                      </van-col>
                    </van-row>
                </van-collapse-item>
              </van-collapse>
        </van-popup>
        <TabMenu />
        <BackTop />
    </div>
</template>
<script>
import { NavBar, Row, Col,List,Picker,Popup,Collapse, CollapseItem,Field,Button } from "vant";
import TabMenu from "../components/TabMenu.vue";
export default {
  name: "goodlist",
  components: {
    TabMenu,
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [List.name]:List,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [Collapse.name]:Collapse,
    [CollapseItem.name]:CollapseItem,
    [Field.name]:Field,
    [Button.name]:Button
  },
  data() {
    return {
      goodsList:[],
      finished:false,
      pages:1,
      brands:[],
      gcId:'',
      areas:[],
      orderBy:0,
      params:{},
      loading:false,
      apiUrl:'',
      q:'',
      popShow:false,
      areaText:'地区筛选',
      activeNames: ['1','2','3'],
      areaId:0,
      brandId:0,
      orderType:true,//是否是倒排 默认倒排
      minPrices:0,
      maxPrices:10000,
    };
  },
  methods: {
      back(){
          history.back();
          // this.$router.push("/home")
      },
      onPickerCancel(){
        this.popShow = false;
      },
      onPickerConfirm(values){
        this.company  = values.orgName;
        this.popShow = false;
        this.params.areaId = values.id;
        this.params.currentPage = 1;
        this.pages = 1;
        this.goodsList = [];
        this.loadData();
      },
      showPop(){
        this.popShow = true;
      },
      areaByList(i){
        this.areaId = this.areas[i].id;
        this.params.areaId = this.areas[i].id;
        this.params.currentPage = 1;
        this.pages = 1;
        this.goodsList = [];
        this.loadData();
        this.popShow = false;
      },
      brandByList(i){
        this.brandId = this.brands[i].id;
        this.params.brandId = this.brands[i].id;
        this.params.currentPage = 1;
        this.pages = 1;
        this.goodsList = [];
        this.loadData();
        this.popShow = false;
      },
      priceByList(){
        this.params.minPrices = this.minPrices;
        this.params.maxPrices = this.maxPrices;
        this.params.currentPage = 1;
        this.pages = 1;
        this.goodsList = [];
        this.loadData();
        this.popShow = false;
      },
      orderByList(i){
        if(this.orderBy == i){
          //第二次点击
          //排序反转
          this.orderType = !this.orderType;
        }else{
          this.orderType = true;
        }
        this.orderBy = i;
        if(this.orderBy == 0){
          this.params.orderBy = 'goods_salenum';
        }else if(this.orderBy == 1){
          this.params.orderBy = 'goods_current_price';
        }else if(this.orderBy == 2){
          this.params.orderBy = 'goods_collect';
        }
        this.params.orderType = this.orderType?'desc':'asc';
        this.params.currentPage = 1;
        this.pages = 1;
        this.goodsList = [];
        this.loadData();
      },
      loadData(){
        if(this.params.currentPage > this.pages){
          this.finished = true;
          this.loading = false;
          return;
        }
        this.finished = false;
        this.loading = true;
        this.getGoodsList();
      },
      getGoodsList(){
        let that = this;
        this.$api.post(this.apiUrl,this.params,
          successRes =>{
            that.goodsList =  that.goodsList.concat(successRes.data.list);
            that.pages = successRes.data.pages;
            that.params.currentPage++;
            that.loading = false;
          })
      },
      getGoodsListSuch(){
          this.params.currentPage = 1;
          this.pages = 1;
          this.goodsList = [];
          this.params.keyword = this.q;
          this.getGoodsList();
      },
      onSubmit(){
          this.params.currentPage = 1;
          this.pages = 1;
          this.goodsList = [];
          this.params.keyword = this.q;
          this.getGoodsList();
      },
      addCart(goodsId){
        let that = this;
        that.$api.addCart(goodsId,1,1,
            successRes=>{
              that.$toast(successRes.msg);
              if(successRes.success){
              }else{
              }
          });
      },
  },
  filters:{
      priceFmt(price){
          if (localStorage.getItem('token')==null) {
              return '会员登录查看';
          }else if(price == null ||price==0){
              return '已售罄';
          }
          return '￥'+price;
      }
  },
  mounted(){
    let that = this;
    //判断如果是刘海屏，则置顶
    if(that.$checkMobile.isIPhoneX() || that.$checkMobile.isIPhoneXSMax() ||that.$checkMobile.isIPhoneXR()){
        that.topDiv=true;
    }
    this.params.currentPage = 1;

    if(this.$route.query.goodsClassId !=null){
      this.apiUrl = this.jumuc.goodsList;
      this.params.goodsClassId = this.$route.query.goodsClassId;
      //初始化分类查询参数
      this.$api.post(this.jumuc.goodsListInit,{goodsClassId:that.params.goodsClassId},
          successRes =>{
            that.brands = successRes.data.brands;
            that.gcId=successRes.data.gcId;
            that.areas = successRes.data.areas;
        })
    }else if(this.$route.query.q !=null){
      this.params.keyword = this.$route.query.q;
      this.apiUrl = this.jumuc.search;
      this.q = this.$route.query.q;
       //初始化分类查询参数
      this.$api.post(this.jumuc.goodsListInit,{goodsClassId:that.params.goodsClassId},
          successRes =>{
            that.brands = successRes.data.brands;
            that.gcId=successRes.data.gcId;
            that.areas = successRes.data.areas;
        })
    }
  },  
  activated(){
    this.params = JSON.parse(localStorage.getItem("good_list_params"));
    this.goodsList = JSON.parse(localStorage.getItem("good_list_data"));
    this.pages = localStorage.getItem("good_list_pages");
  },
  beforeRouteLeave (to, from, next) {
    if(to.name == "gooddetail"){
      from.meta.keepAlive = true;
      //缓存
      localStorage.setItem("good_list_params",JSON.stringify(this.params));
      localStorage.setItem("good_list_data",JSON.stringify(this.goodsList));
      localStorage.setItem("good_list_pages",this.pages);
    }else{
      from.meta.keepAlive = false;
    }
    next();
  },
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
.jump-goodlist {
  &-header {
    position: fixed;
    top: env(safe-area-inset-top);
    left: 0px;
    width: 100%;
    background-color: @bule-thame;
    z-index: 9999;
  }
  &-navbar {
    &-arrow {
      line-height: 40px;
      text-align: center;
    }
    i {
      font-size: 20px;
      color: #ffffff;
      vertical-align: -5px;
    }
    input {
      height: 30px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      border-radius: 15px;
      margin-top: 8px;
    }
  }
  &-filter {
    padding: 15px;
    &-item {
      font-size: 14px;
      i {
        vertical-align: -2px;
        padding-left: 3px;
      }
    }
  }
  &-body {
    padding: 10px 10px 50px;
    &-item {
      margin-bottom: 15px;
      .img-hd {
        width: 100%;
        background-color: #fff;
        padding: 10px;
        img {
          width: 100%;
          border-radius: 50%;
        }
      }
      &:nth-of-type(even) {
        padding-left: 5px;
      }
      &:nth-of-type(odd) {
        padding-right: 5px;
      }

      h4 {
        font-size: 14px;
        padding: 10px 0;
      }
      p {
        font-size: 14px;
        color: red;
        i {
          padding-right: 5px;
          font-style: normal;
        }
      }
    }
  }
  
  &-item {
    background-color: #fff;
    margin-bottom: 15px;
    align-items: center;
    border-radius: 20px;
    padding: 20px;
    position: relative;
    .van-checkbox {
      height: 100%;
      line-height: 100%;
    }
    &-img {
      img {
        width: 90%;
      }
    }

    h4 {
      font-size: 14px;
      padding: 10px 0;
    }
    &-warp {
      align-self: flex-start;
      h4 {
        a {
          font-size: 14px;
          color: rgb(91,95,98);
          font-family: PingFangSC-Regular;
        }
      }
    }
    p {
      font-size: 14px;
        &.item-price {
            color: rgb(208,2,27);
            font-size: 18px;
            font-family: PingFangSC-Medium;
            position: relative;
                i{
                    position: absolute;
                    right: 0;
                    font-size: 24px;
                    color: #f5a623
                }
        }
    }
  }
  .active{
    color: @bule-thame;
  }
  .van-popup--right {
    width: 80%;
    height: 100%;
    padding-top: 55px;
  }
  .pop-item{
    margin-right: 15px;
    margin-bottom: 15px;
    display: inline-block;
  }
}
.gooddlist-filter{
    .van-field__control{
      border-bottom: 1px solid #ebedf0;
    }
    button{
      color: #fff;
      border-color: @bule-thame;
      background-color: @bule-thame;
      margin-top: 5px;
    }
}

 .jianjie-title {
        overflow: hidden;
        text-overflow: ellipsis; /* 文本溢出 ... */
        display: -webkit-box;
        -webkit-line-clamp: 3; /* 规定显示行数... */
        -webkit-box-orient: vertical;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height:22px;
    }
</style>
